import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 1. Ant Design
import { Alert, Button, Card, message, Result, Skeleton } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
// 3. Internal components
import TariffPairForm from "@/components/TariffPairForm";
// 4. Stores
import { getRootStore } from "@/stores/RootStore";
import { isAdmin } from "@/utils/permissions";
import styles from "@/styles/CompanyPage.module.less";
/**
 * Вкладка «Тарифы» (P-4, UC1114): пара тарифов компании из `v_corp_tariff_pairs` в общей форме.
 * Правит только ADMINISTRATOR — те же права, что у общих тарифов (D14, BR-TRF-04), проверка по `isAdmin`,
 * а не по `COMPANIES_WRITE`; остальные видят форму только для чтения.
 */
const TariffsTab = observer(() => {
    const { authStore, singleCompanyStore: store } = getRootStore();
    const canEdit = isAdmin(authStore.userRole);
    useEffect(() => {
        void store.loadTariffPair();
    }, [store.companyId]);
    const handleSubmit = async (pair) => {
        const saved = await store.saveTariffPair(pair);
        if (saved)
            message.success("Тариф компании сохранён");
    };
    if (store.tariffLoading && !store.tariffPair) {
        return (_jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }));
    }
    if (!store.tariffPair && store.tariffError) {
        return (_jsx(Result, { status: "error", title: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0442\u0430\u0440\u0438\u0444 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438", subTitle: store.tariffError, extra: _jsx(Button, { type: "primary", onClick: () => void store.loadTariffPair(), children: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C" }) }));
    }
    if (!store.tariffPair) {
        return (_jsx(Result, { status: "warning", title: "\u0423 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u043D\u0435\u0442 \u0442\u0430\u0440\u0438\u0444\u0430", subTitle: "\u041F\u0430\u0440\u0430 \u0442\u0430\u0440\u0438\u0444\u043E\u0432 \u0441\u043E\u0437\u0434\u0430\u0451\u0442\u0441\u044F \u0432\u043C\u0435\u0441\u0442\u0435 \u0441 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0435\u0439 \u2014 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430\u043C" }));
    }
    return (_jsxs(Card, { title: "\u041F\u0430\u0440\u0430 \u0442\u0430\u0440\u0438\u0444\u043E\u0432 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438", className: styles.section, children: [_jsx(Alert, { type: "info", showIcon: true, className: styles.notice, message: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u043D\u0430 \u0437\u0430\u043A\u0430\u0437\u044B, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u0441\u043B\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F", description: canEdit
                    ? "У уже созданных заказов цена зафиксирована при создании. Общие тарифы эта правка не меняет."
                    : "Тариф компании правит администратор системы." }), _jsx(TariffPairForm, { mode: "company", pair: store.tariffPair, canEdit: canEdit, isSaving: store.tariffSaving, onSubmit: handleSubmit })] }));
});
TariffsTab.displayName = "TariffsTab";
export default TariffsTab;
